import React from "react";
import { FormattedMessage } from "react-intl";

const Content = () => {
  return (
    <div className="content">
      <p>
        <FormattedMessage id="content.header" />
      </p>
      <ul>
        <li>
          <FormattedMessage id="content.item1" />
        </li>
        <li>
          <FormattedMessage id="content.item2" />
        </li>
        <li>
          <FormattedMessage id="content.item3" />
        </li>
        <li>
          <FormattedMessage id="content.item4" />
        </li>
      </ul>
    </div>
  );
};

export default Content;
